import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Container, Row, Col, Collapse, Button, CardBody, Card } from 'reactstrap';
import './style.scss';
import ReactAudioPlayer from 'react-audio-player';


class Context extends Component {

    constructor(props) {
        super(props);
        this.state = { collapse: false };
    }

    toggle = () => {
        this.setState({ collapse: !this.state.collapse });
    }

    render() {
        if (this.props.vertical) {
            return (<Container>
                <Row>
                    <ReactAudioPlayer
                        controlsList = {"nodownload"}
                        src={this.props.audio}
                        hidePlayer={true}
                        controls
                    />
                </Row>
                <Row>
                    <Button color="primary" onClick={this.toggle} style={{ marginBottom: '1rem' }}>Script</Button>
                    <Collapse isOpen={this.state.collapse}>
                        <Card>
                            <CardBody>
                                {this.props.script}
                            </CardBody>
                        </Card>
                    </Collapse>
                </Row>
            </Container>)
        } else {
            return (<Container>
                <Row>
                    <Col xs="6">
                        <ReactAudioPlayer
                            src={this.props.audio}
                            hidePlayer={true}
                            controls
                        />
                    </Col>
                    <Col xs="6">
                        <Button color="primary" onClick={this.toggle} style={{ marginBottom: '1rem' }}>Script</Button>
                        <Collapse isOpen={this.state.collapse}>
                            <Card>
                                <CardBody>
                                    {this.props.script}
                                </CardBody>
                            </Card>
                        </Collapse>
                    </Col>
                </Row>
            </Container>)
        }
    }
}


Context.propTypes = {
    audio: PropTypes.string.isRequired,
    script: PropTypes.string.isRequired
};


export default Context;



